// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2Mosc","content":"Consent_content__IWp5q","footer":"Consent_footer__2MNOv"};